import React, { useEffect, useState, useCallback } from 'react';
import { apiService } from '../../../components/Config/api.service';
import Select from "react-select";
import AbsenceType from './AbsenceType';
import { differenceInDays, parseISO } from 'date-fns';
import { notify } from '../../../components/Utils/Notifications';
import ActionDropdown from '../../../components/Utils/ActionDropdown';
import { FaRegTrashAlt } from 'react-icons/fa';
import AsyncSelect from "react-select/async"; 
import EmployeeSelect from "../../../components/Formulaire/EmployeeSelect";


const AbsenceForm = ({ setIsDrawerOpen, id, refreshAbsenceList }) => {

    const [formData, setFormData] = useState({
        selectedEmployee: null,
        date: "",
        date_end: "",
        hours: 8,
        absenceType: null,
        description: "",
    });

    const { date, date_end, hours, absenceType, selectedEmployee, description } = formData;
    const [absenceTypes, setAbsenceTypes] = useState([]);
    const [showAbsenceTypeManager, setShowAbsenceTypeManager] = useState(false);

    // utiliser la meme logique que pour employeeSelect pour supprimer le fetch absenceTypes
    const fetchAbsenceTypes = useCallback(async () => {
        try {
            const response = await apiService.getElement('/absence_types');
            if (response.data && response.data.data) {
                const typesOptions = response.data.data.map(type => ({
                    value: type.category,
                    label: type.name,
                    id: type.id
                }));
                setAbsenceTypes(typesOptions);
            }
        } catch (error) {
            console.error('Error fetching absence types:', error);
            notify('Erreur lors de la récupération des types d\'absence.', ', 3');
        }
    }, []);

    const updateFormData = useCallback((field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    }, []);

    const calculateDays = useCallback(() => {
        if (date && date_end) {

            let diffDays = differenceInDays(parseISO(date_end), parseISO(date)) ;

            if (date === date_end && hours < 8) {
                diffDays = hours / 8;
            }

            return diffDays.toFixed(2);
        }
        return "0";
    }, [date, date_end, hours]);

    useEffect(() => {
        fetchAbsenceTypes();

        if (id) {
            apiService.getElementById('/absences', id)
                .then(response => {
                    const absenceData = response.data.absence;
                    const absenceTypeValue = absenceTypes.find(type => type.id === absenceData.absenceType) || null;
                    setFormData({
                        selectedEmployee: {
                            value: absenceData.employee_id,
                            label: absenceData.employee_name 
                        },
                        date: absenceData.date || "",
                        date_end: absenceData.date_end || "",
                        hours: absenceData.hours || 8,
                        absenceType: absenceTypeValue,
                        description: absenceData.description || ""
                    });
                })
                .catch(error => {
                    console.error('Error fetching absence data:', error);
                    notify('Erreur lors de la récupération des données d\'absence.', '', 3);
                });
        } else {
            setFormData({
                selectedEmployee: null,
                date: "",
                date_end: "",
                hours: 8,
                absenceType: null,
                description: ""
            });
        }
    }, [fetchAbsenceTypes, id]);

    const refreshAbsenceTypes = () => {
        fetchAbsenceTypes();
        setShowAbsenceTypeManager(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const updatedFormData = {
            selectedEmployee: formData.selectedEmployee.value || null,
            employee_name: formData.selectedEmployee.label || "",
            date: formData.date,
            date_end: formData.date_end || formData.date,
            hours: parseFloat(formData.hours) || 8,
            absenceType: formData.absenceType?.id || null,
            description: formData.description || ""
        };

        console.log('Form Data Submitted:', updatedFormData);

        if (id) {
            apiService.updateElementById(`/absences`, id, updatedFormData)
                .then(response => {
                    notify('Mise à jours réussi', '', 2);
                    setIsDrawerOpen(false);
                    refreshAbsenceList();
                })
                .catch(error => {
                    console.error('Error updating absence:', error);
                    notify('Erreur lors de la mise à jour des absences.', '', 3);
                }
                );
        } else {
            apiService.saveElement(`/absence`, updatedFormData)
                .then(response => {
                    notify('Création réussi', '', 2);
                    setIsDrawerOpen(false);
                    refreshAbsenceList();
                })
                .catch(error => {
                    console.error('Error creating absence:', error);
                    notify('Erreur lors de la création de l\'absence.', '', 3);
                });
        }
    };

    const handleDelete = async () => {
        if (!window.confirm('Êtes-vous sûr de vouloir supprimer cette absence?')) {
            return;
        }
        try {
            const updatedFormData = {
                active: false,
            };
            apiService.updateElementById(`/absences`, id, updatedFormData)
                .then(response => {
                    notify('Suppression réussi', '', 2);
                    setIsDrawerOpen(false);
                    refreshAbsenceList();
                })
        } catch (error) {
            console.error('Error deleting absence:', error);
            notify('Erreur lors de la suppression de l\'absence.', '', 3);
        }
    };
    const [loading, setLoading] = useState(false);
    
    const dropdownActions = [
            {
                label: 'Supprimer',
                onClick: handleDelete,
                disabled: loading || !id,
                color: 'text-red-500',
                icon: <FaRegTrashAlt size={16} />
            }
        ]

    return (
        <div>
            <div className="menu p-6 h-screen w-full max-w-3xl bg-white text-base-content overflow-y-auto">
            <div>
                <div className="flex justify-between items-center">
                    <h2 className="text-lg font-semibold mb-4">{id ? "Modifier l'absence" : "Ajouter une absence"}</h2>
                    {id && (
                        <ActionDropdown actions={dropdownActions} />
                    )}
                </div>
            </div>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-sm font-medium mb-1">Nom de l'employé</label>
                        <EmployeeSelect
                            value={selectedEmployee}
                            onChange={option => updateFormData('selectedEmployee', option)}
                            placeholder="Saisir le nom de l'employé"
                            minInputLength={2}
                        />
                    </div>

                    <div className="mb-4">
                        {/* <div className="flex justify-between items-center mb-1">
                            <label className="block text-sm font-medium">Type d'absence</label>
                            <button
                                type="button"
                                className="text-sm text-blue-600 hover:underline"
                                onClick={() => setShowAbsenceTypeManager(true)}
                            >
                                Gérer les types
                            </button>
                        </div> */}
                        <Select
                            id="absenceType"
                            options={absenceTypes.length > 0 ? absenceTypes : []}
                            value={absenceType}
                            onChange={(value) => updateFormData('absenceType', value)}
                            placeholder="Choisir un type d'absence"
                            className="react-select-container"
                            classNamePrefix="react-select"
                        />
                    </div>

                    <div className="grid grid-cols-2 gap-4 mb-4">
                        <div>
                            <label className="block text-sm font-medium mb-1">Date de début</label>
                            <input
                                type="date"
                                id="date"
                                name="date"
                                className="input input-bordered w-full"
                                value={date}
                                onChange={(e) => updateFormData('date', e.target.value)}
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">Date de retour</label>
                            <input
                                type="date"
                                id="date_end"
                                name="date_end"
                                className="input input-bordered w-full"
                                value={date_end}
                                onChange={(e) => updateFormData('date_end', e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium mb-1">
                            Nombre d'heures {date && date_end && date === date_end ? "(pour absence partielle)" : ""}
                        </label>
                        <input
                            type="number"
                            id="hours"
                            name="hours"
                            className="input input-bordered w-full"
                            value={hours}
                            step="0.5"
                            min="0"
                            max="8"
                            onChange={(e) => updateFormData('hours', parseFloat(e.target.value) || 0)}
                            disabled={date && date_end && date !== date_end}
                        />
                        {date && date_end && date !== date_end && (
                            <p className="text-xs text-gray-600 mt-1">
                                Pour une période de plusieurs jours, les heures ne peuvent pas être modifiées.
                            </p>
                        )}
                    </div>

                    <div className="mb-4 p-3 bg-gray-100 rounded-md">
                        <h3 className="font-medium text-sm mb-1">Résumé de l'absence</h3>
                        <p className="text-sm">Jours totaux: <span className="font-semibold">{calculateDays()}</span></p>
                        <p className="text-xs text-gray-600 mt-1">
                            Les jours seront calculés automatiquement selon le type d'absence sélectionné.
                        </p>
                    </div>

                    <div className="mb-6">
                        <label className="block text-sm font-medium mb-1">Description</label>
                        <textarea
                            id="description"
                            name="description"
                            className="textarea textarea-bordered w-full"
                            value={description || ""}
                            onChange={(e) => updateFormData('description', e.target.value)}
                            rows="3"
                        ></textarea>
                    </div>

                    {showAbsenceTypeManager && (
                        <div className="fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-50 flex items-center justify-center">
                            <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
                                <AbsenceType
                                    setIsDrawerOpen={setShowAbsenceTypeManager}
                                    refreshParent={refreshAbsenceTypes}
                                    isInForm={true}
                                />
                            </div>
                        </div>
                    )}

                    <div className="flex justify-end gap-4">
                        <button
                            type="button"
                            className="btn btn-outline"
                            onClick={() => setIsDrawerOpen(false)}
                        >
                            Annuler
                        </button>
                        <button type="submit" className="btn btn-outline bg-[--color-primary] text-white">
                            {id ? "Mettre à jour" : "Ajouter"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AbsenceForm;